import fetch from '.';

export const fetchServiceType = req =>
  fetch({
    url: '/dcxy/other/serviceType/manager/queryServiceType',
  });
